const mutations = {
    setModal: (state, payload) => {
        state.isOpen = payload.isOpen
        state.isConfirm = payload.isConfirm !== undefined ? payload.isConfirm : false
        state.ok = payload.ok !== undefined ? payload.ok : 'OK'
        state.title = payload.title !== undefined ? payload.title : '確認'
        state.cancel = payload.cancel !== undefined ? payload.cancel : 'キャンセル'
        state.message = payload.message
        state.resolve = payload.resolve
        state.reject = payload.reject
    },

    resetModalState(state) {
        state.isOpen = false
        state.isConfirm = false
        state.resolve = (bool) => bool
        state.reject = (bool) => bool
    },
};

export default mutations;